import { render, staticRenderFns } from "./UcProjectMiniCard.yaml?vue&type=template&id=8ced394c&component"
import script from "./UcProjectMiniCard.yaml?vue&type=script&lang=ts&component"
export * from "./UcProjectMiniCard.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports